import { AdvertDestination } from '@/types';
import { IsEnum } from 'class-validator';

export class AdvertDestinationSectionEditInput {
  @IsEnum(AdvertDestination, { message: 'Please enter a destination' })
  advertDestination: AdvertDestination;
}
